import VehicleAddOrUpdateContent from "../content/vehicleAddOrUpdateContent";
import Layout from "../layout/Layout";

const VehicleAddOrUpdate = () => {
  return (
    <Layout>
      <VehicleAddOrUpdateContent />
    </Layout>
  );
};

export default VehicleAddOrUpdate;
